<template>
  <section
    v-if="variants.v1 === variant"
    class="layout-pt-lg layout-pb-lg"
    :style="`background-color: var(--c-${vars.backgroundColor}); color: var(--c-${vars.textColor});`"
  >
    <div class="tw-w-full">
      <div class="tw-space-y-10">
        <div
          v-for="(branch, index) in branches"
          :key="`contact-us-branch-${index}`"
          class="tw-grid tw-grid-cols-1 tw-items-center tw-overflow-hidden xl:tw-grid-cols-2"
        >
          <div class="tw-p-6">
            <LibraryImage :src="branch.photo" :w-ratio="720" :h-ratio="405" />
          </div>

          <div class="tw-p-6 md:tw-p-6 lg:tw-p-10">
            <div>
              <div v-if="vars.titleHtml" class="tw-mb-8" v-html="vars.titleHtml"></div>
            </div>
            <h3 v-if="branch.title" class="tw-mb-4">{{ branch.title }}</h3>

            <div class="tw-grid tw-grid-cols-1 tw-gap-5 lg:tw-grid-cols-2">
              <div class="tw-col-span-1 tw-space-y-8">
                <div class="tw-items-start">
                  <div class="tw-min-w-9"></div>

                  <div class="tw-flex tw-w-full tw-flex-col tw-items-start tw-space-y-2">
                    <small>ADDRESS</small>
                    <nuxt-link
                      v-if="branch.address"
                      :to="branch.address_link"
                      class="n-link"
                      style="color: cornflowerblue !important; font-weight: 600 !important"
                      :external="true"
                    >
                      {{ branch.address }}
                    </nuxt-link>
                  </div>
                </div>

                <div v-if="branch.primary_phone" class="tw-items-start">
                  <div class="tw-min-w-9"></div>
                  <div class="tw-w-full tw-space-y-2">
                    <small>PHONE</small>
                    <p :style="`color: var(--c-${vars.textColor}) !important;`">
                      <nuxt-link
                        :to="`tel:${branch.primary_phone}`"
                        class="n-link"
                        style="color: cornflowerblue !important; font-weight: 600 !important"
                        :external="true"
                      >
                        {{ branch.primary_phone }}
                      </nuxt-link>
                    </p>
                  </div>
                </div>

                <!-- E-Posta -->
                <div v-if="branch.primary_email" class="tw-items-start">
                  <div class="tw-min-w-9"></div>
                  <div class="tw-line-clamp-2 tw-space-y-2">
                    <small>EMAIL</small>
                    <p
                      :style="`color: var(--c-${vars.textColor}) !important;`"
                      :title="branch.primary_email"
                      class="scrollbar tw-overflow-x-auto"
                    >
                      <nuxt-link
                        v-if="branch.primary_email"
                        :to="`mailto:${branch.primary_email}`"
                        class="n-link"
                        style="color: cornflowerblue !important; font-weight: 600 !important"
                        :external="true"
                      >
                        {{ branch.primary_email }}
                      </nuxt-link>
                    </p>
                  </div>
                </div>

                <div
                  v-if="
                    branch.facebook_url ||
                    branch.instagram_url ||
                    branch.linkedin_url ||
                    branch.youtube_url ||
                    branch.tiktok_url
                  "
                  class="tw-items-start"
                >
                  <div class="tw-min-w-9"></div>
                  <div class="tw-w-full tw-space-y-2">
                    <small>SOCIALS</small>
                    <div class="tw-flex tw-gap-3">
                      <!-- Facebook -->
                      <a
                        v-if="branch.facebook_url"
                        :href="branch.facebook_url || '#'"
                        class="n-link tw-group"
                        target="_blank"
                      >
                        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="18" cy="18" r="18" fill="#1B3B47" />
                          <path
                            d="M19.3346 19H21.0013L21.668 16.3334H19.3346V15C19.3346 14.3134 19.3346 13.6667 20.668 13.6667H21.668V11.4267C21.4506 11.398 20.63 11.3334 19.7633 11.3334C17.9533 11.3334 16.668 12.438 16.668 14.4667V16.3334H14.668V19H16.668V24.6667H19.3346V19Z"
                            fill="white"
                          />
                        </svg>
                      </a>

                      <!-- Instagram -->
                      <a
                        v-if="branch.instagram_url"
                        :href="branch.instagram_url || '#'"
                        class="n-link tw-group"
                        target="_blank"
                      >
                        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="18" cy="18" r="18" fill="#1B3B47" />
                          <path
                            d="M15.1987 11.3334H20.7987C22.932 11.3334 24.6654 13.0667 24.6654 15.2V20.8C24.6654 21.8255 24.258 22.809 23.5328 23.5342C22.8077 24.2593 21.8242 24.6667 20.7987 24.6667H15.1987C13.0654 24.6667 11.332 22.9334 11.332 20.8V15.2C11.332 14.1745 11.7394 13.191 12.4646 12.4659C13.1897 11.7408 14.1732 11.3334 15.1987 11.3334ZM15.0654 12.6667C14.4288 12.6667 13.8184 12.9196 13.3683 13.3697C12.9182 13.8197 12.6654 14.4302 12.6654 15.0667V20.9334C12.6654 22.26 13.7387 23.3334 15.0654 23.3334H20.932C21.5686 23.3334 22.179 23.0805 22.6291 22.6304C23.0792 22.1803 23.332 21.5699 23.332 20.9334V15.0667C23.332 13.74 22.2587 12.6667 20.932 12.6667H15.0654ZM21.4987 13.6667C21.7197 13.6667 21.9317 13.7545 22.088 13.9108C22.2442 14.0671 22.332 14.279 22.332 14.5C22.332 14.7211 22.2442 14.933 22.088 15.0893C21.9317 15.2456 21.7197 15.3334 21.4987 15.3334C21.2777 15.3334 21.0657 15.2456 20.9094 15.0893C20.7532 14.933 20.6654 14.7211 20.6654 14.5C20.6654 14.279 20.7532 14.0671 20.9094 13.9108C21.0657 13.7545 21.2777 13.6667 21.4987 13.6667ZM17.9987 14.6667C18.8828 14.6667 19.7306 15.0179 20.3557 15.643C20.9808 16.2681 21.332 17.116 21.332 18C21.332 18.8841 20.9808 19.7319 20.3557 20.3571C19.7306 20.9822 18.8828 21.3334 17.9987 21.3334C17.1146 21.3334 16.2668 20.9822 15.6417 20.3571C15.0166 19.7319 14.6654 18.8841 14.6654 18C14.6654 17.116 15.0166 16.2681 15.6417 15.643C16.2668 15.0179 17.1146 14.6667 17.9987 14.6667ZM17.9987 16C17.4683 16 16.9596 16.2108 16.5845 16.5858C16.2094 16.9609 15.9987 17.4696 15.9987 18C15.9987 18.5305 16.2094 19.0392 16.5845 19.4143C16.9596 19.7893 17.4683 20 17.9987 20C18.5291 20 19.0378 19.7893 19.4129 19.4143C19.788 19.0392 19.9987 18.5305 19.9987 18C19.9987 17.4696 19.788 16.9609 19.4129 16.5858C19.0378 16.2108 18.5291 16 17.9987 16Z"
                            fill="white"
                          />
                        </svg>
                      </a>

                      <!-- LinkedIn -->
                      <a
                        v-if="branch.linkedin_url"
                        :href="branch.linkedin_url || '#'"
                        class="n-link tw-group"
                        target="_blank"
                      >
                        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="18" cy="18" r="18" fill="#1B3B47" />
                          <path
                            d="M14.6276 13.3334C14.6274 13.687 14.4868 14.0261 14.2366 14.276C13.9864 14.5259 13.6472 14.6662 13.2936 14.6661C12.94 14.6659 12.6009 14.5252 12.351 14.2751C12.1011 14.0249 11.9608 13.6857 11.9609 13.3321C11.9611 12.9784 12.1018 12.6394 12.3519 12.3894C12.6021 12.1395 12.9413 11.9992 13.2949 11.9994C13.6486 11.9996 13.9876 12.1402 14.2376 12.3904C14.4875 12.6406 14.6278 12.9798 14.6276 13.3334ZM14.6676 15.6534H12.0009V24.0001H14.6676V15.6534ZM18.8809 15.6534H16.2276V24.0001H18.8543V19.6201C18.8543 17.1801 22.0343 16.9534 22.0343 19.6201V24.0001H24.6676V18.7134C24.6676 14.6001 19.9609 14.7534 18.8543 16.7734L18.8809 15.6534Z"
                            fill="white"
                          />
                        </svg>
                      </a>
                      <a
                        v-if="branch.youtube_url"
                        :href="branch.youtube_url || '#'"
                        class="n-link tw-group"
                        target="_blank"
                      >
                        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="18" cy="18" r="18" fill="#1B3B47" />
                          <g clip-path="url(#clip0_79_2241)">
                            <path
                              d="M17.9987 12.6666C18.5687 12.6666 19.1534 12.6813 19.72 12.7053L20.3894 12.7373L21.03 12.7753L21.63 12.816L22.178 12.8586C22.7727 12.9041 23.3323 13.1579 23.7584 13.5753C24.1844 13.9927 24.4496 14.547 24.5074 15.1406L24.534 15.424L24.584 16.0306C24.6307 16.6593 24.6654 17.3446 24.6654 18C24.6654 18.6553 24.6307 19.3406 24.584 19.9693L24.534 20.576C24.5254 20.6733 24.5167 20.7673 24.5074 20.8593C24.4496 21.453 24.1843 22.0074 23.7581 22.4248C23.3319 22.8422 22.7722 23.0959 22.1774 23.1413L21.6307 23.1833L21.0307 23.2246L20.3894 23.2626L19.72 23.2946C19.1466 23.3195 18.5727 23.3324 17.9987 23.3333C17.4247 23.3324 16.8508 23.3195 16.2774 23.2946L15.608 23.2626L14.9674 23.2246L14.3674 23.1833L13.8194 23.1413C13.2247 23.0958 12.6651 22.842 12.239 22.4246C11.813 22.0072 11.5477 21.4529 11.49 20.8593L11.4634 20.576L11.4134 19.9693C11.3624 19.3141 11.3353 18.6572 11.332 18C11.332 17.3446 11.3667 16.6593 11.4134 16.0306L11.4634 15.424C11.472 15.3266 11.4807 15.2326 11.49 15.1406C11.5477 14.5471 11.8128 13.9929 12.2388 13.5755C12.6647 13.1581 13.2241 12.9043 13.8187 12.8586L14.366 12.816L14.966 12.7753L15.6074 12.7373L16.2767 12.7053C16.8504 12.6804 17.4245 12.6675 17.9987 12.6666ZM17.9987 14C17.4487 14 16.8827 14.0146 16.332 14.0373L15.68 14.0686L15.054 14.1053L14.466 14.1453L13.9274 14.1873C13.6443 14.2074 13.3774 14.3271 13.1741 14.5251C12.9708 14.7232 12.8442 14.9868 12.8167 15.2693C12.7387 16.0753 12.6654 17.0786 12.6654 18C12.6654 18.9213 12.7387 19.9246 12.8167 20.7306C12.8734 21.312 13.3347 21.764 13.9274 21.8126L14.466 21.854L15.054 21.894L15.68 21.9313L16.332 21.9626C16.8827 21.9853 17.4487 22 17.9987 22C18.5487 22 19.1147 21.9853 19.6654 21.9626L20.3174 21.9313L20.9434 21.8946L21.5314 21.8546L22.07 21.8126C22.3531 21.7925 22.62 21.6729 22.8233 21.4748C23.0266 21.2768 23.1532 21.0131 23.1807 20.7306C23.2587 19.9246 23.332 18.9213 23.332 18C23.332 17.0786 23.2587 16.0753 23.1807 15.2693C23.1532 14.9868 23.0266 14.7232 22.8233 14.5251C22.62 14.3271 22.3531 14.2074 22.07 14.1873L21.5314 14.146L20.9434 14.106L20.3174 14.0686L19.6654 14.0373C19.1101 14.0134 18.5545 14.001 17.9987 14ZM16.6654 16.3833C16.6653 16.3181 16.6812 16.254 16.7116 16.1963C16.742 16.1387 16.786 16.0894 16.8399 16.0526C16.8937 16.0159 16.9557 15.9929 17.0204 15.9856C17.0851 15.9782 17.1507 15.9868 17.2114 16.0106L17.2654 16.0373L20.0654 17.6533C20.1211 17.6855 20.1683 17.7306 20.2029 17.7849C20.2374 17.8392 20.2584 17.9011 20.264 17.9652C20.2695 18.0293 20.2595 18.0939 20.2348 18.1533C20.2101 18.2127 20.1714 18.2653 20.122 18.3066L20.0654 18.3466L17.2654 19.9633C17.2089 19.996 17.1454 20.0144 17.0802 20.0168C17.0151 20.0193 16.9503 20.0059 16.8915 19.9776C16.8328 19.9493 16.7818 19.9072 16.7431 19.8547C16.7044 19.8022 16.6791 19.7411 16.6694 19.6766L16.6654 19.6166V16.3833Z"
                              fill="white"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_79_2241">
                              <rect width="16" height="16" fill="white" transform="translate(10 10)" />
                            </clipPath>
                          </defs>
                        </svg>
                      </a>

                      <!-- TikTok -->
                      <a
                        v-if="branch.tiktok_url"
                        :href="branch.tiktok_url || '#'"
                        class="n-link tw-group"
                        target="_blank"
                      >
                        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="18" cy="18" r="18" fill="#1B3B47" />
                          <path
                            d="M21.0668 13.88C20.6111 13.3597 20.3599 12.6916 20.3601 12H18.3001V20.2667C18.2842 20.714 18.0954 21.1377 17.7733 21.4486C17.4512 21.7595 17.0211 21.9333 16.5734 21.9333C15.6268 21.9333 14.8401 21.16 14.8401 20.2C14.8401 19.0533 15.9468 18.1933 17.0868 18.5467V16.44C14.7868 16.1333 12.7734 17.92 12.7734 20.2C12.7734 22.42 14.6134 24 16.5668 24C18.6601 24 20.3601 22.3 20.3601 20.2V16.0067C21.1954 16.6066 22.1983 16.9284 23.2268 16.9267V14.8667C23.2268 14.8667 21.9734 14.9267 21.0668 13.88Z"
                            fill="white"
                          />
                        </svg>
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <div class="tw-items-start">
                  <div class="tw-w-9"></div>
                  <div class="tw-w-full">
                    <small>OPENING HOURS</small>
                    <div>
                      <div class="tw-mt-4 tw-space-y-4 tw-text-[#545454]">
                        <div class="tw-flex tw-justify-between">
                          <p :style="`color: var(--c-${vars.textColor}) !important;`">Monday:</p>
                          <p :style="`color: var(--c-${vars.textColor}) !important;`">{{ branch.monday }}</p>
                        </div>
                        <div class="tw-flex tw-justify-between">
                          <p :style="`color: var(--c-${vars.textColor}) !important;`">Tuesday:</p>
                          <p :style="`color: var(--c-${vars.textColor}) !important;`">{{ branch.tuesday }}</p>
                        </div>
                        <div class="tw-flex tw-justify-between">
                          <p :style="`color: var(--c-${vars.textColor}) !important;`">Wednesday:</p>
                          <p :style="`color: var(--c-${vars.textColor}) !important;`">{{ branch.wednesday }}</p>
                        </div>
                        <div class="tw-flex tw-justify-between">
                          <p :style="`color: var(--c-${vars.textColor}) !important;`">Thursday:</p>
                          <p :style="`color: var(--c-${vars.textColor}) !important;`">{{ branch.thursday }}</p>
                        </div>
                        <div class="tw-flex tw-justify-between">
                          <p :style="`color: var(--c-${vars.textColor}) !important;`">Friday:</p>
                          <p :style="`color: var(--c-${vars.textColor}) !important;`">{{ branch.friday }}</p>
                        </div>
                        <div class="tw-flex tw-justify-between">
                          <p :style="`color: var(--c-${vars.textColor}) !important;`">Saturday:</p>
                          <p :style="`color: var(--c-${vars.textColor}) !important;`">{{ branch.saturday }}</p>
                        </div>
                        <div class="tw-flex tw-justify-between">
                          <p :style="`color: var(--c-${vars.textColor}) !important;`">Sunday:</p>
                          <p :style="`color: var(--c-${vars.textColor}) !important;`">{{ branch.sunday }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section
    v-if="variants.v2 === variant"
    class="layout-pt-lg layout-pb-lg"
    :style="`background-color: var(--c-${vars.backgroundColor}); color: var(--c-${vars.textColor});`"
  >
    <!-- Başlık -->
    <div v-html="vars.titleHtml" class="mb-4 tw-flex tw-flex-row tw-flex-wrap" />

    <div class="tw-grid tw-grid-cols-1 tw-gap-16 md:tw-grid-cols-2 lg:tw-grid-cols-3">
      <div
        v-for="(branch, index) in branches"
        :key="`contact-branch-${index}`"
        class="tw-flex tw-flex-col tw-items-center tw-space-y-6 tw-text-start"
      >
        <!-- Ofis Resmi -->
        <div class="tw-w-72">
          <LibraryImage :src="branch.photo" class="tw-h-full tw-w-full tw-object-cover" />
        </div>

        <!-- Ofis Bilgileri -->
        <div class="tw-w-full tw-space-y-6">
          <!-- Adres -->
          <div class="tw-space-y-3">
            <small :style="`color: var(${vars.textColor}) !important;`">ADDRESS</small>
            <p :style="`color: var(--c-primary) !important;`">
              {{ branch.address }}
            </p>
          </div>

          <!-- Telefon -->
          <div class="tw-space-y-3 tw-min-h-[105px]">
            <small v-if="branch.primary_phone" :style="`color: var(${vars.textColor}) !important;`">PHONE</small>
            <p :style="`color: var(--c-primary) !important;`">
              <a :href="`tel:${branch.primary_phone}`" class="n-link hover:tw-underline">
                {{ branch.primary_phone }} <span :style="`color: var(${vars.textColor}) !important;`"> - Sales </span>
              </a>
            </p>
            <p v-if="branch.secondary_phone" :style="`color: var(--c-primary) !important;`">
              <a :href="`tel:${branch.secondary_phone}`" class="n-link hover:tw-underline">
                {{ branch.secondary_phone }}
                <span :style="`color: var(${vars.textColor}) !important;`"> - Lettings </span>
              </a>
            </p>
          </div>

          <!-- Email -->
          <div class="tw-space-y-3">
            <small :style="`color: var(${vars.textColor}) !important;`">EMAIL</small>
            <p :style="`color: var(--c-primary) !important;`">
              <a :href="`mailto:${branch.primary_email}`" class="n-link hover:tw-underline">
                {{ branch.primary_email }}
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section
    v-if="variants.v3 === variant"
    class="layout-pt-lg layout-pb-lg"
    :style="`background-color: var(--c-${vars.backgroundColor}); color: var(--c-${vars.textColor});`"
  >
    <div class="tw-w-full">
      <div
        v-for="(branch, index) in branches"
        :key="`contact-us-branch-v3-${index}`"
        class="tw-grid tw-grid-cols-1 tw-items-center tw-overflow-hidden xl:tw-grid-cols-2"
      >
        <div
          class="tw-p-6"
          :class="{
            'xl:tw-order-last': branch.reversed,
            'xl:tw-pl-0': !branch.reversed,
            'xl:tw-pr-0': branch.reversed,
          }"
        >
          <LibraryImage
            v-if="branch.photo"
            :src="String(branch.photo)"
            :w-ratio="720"
            :h-ratio="405"
          />
          <LibraryIframe
            v-else-if="branch.video_url"
            :src="String(branch.video_url)"
          />
        </div>

        <div class="tw-p-6 md:tw-p-6 lg:tw-p-10">
          <h3 v-if="branch.title" class="tw-mb-8 tw-text-4xl ">
            {{ branch.title }}
          </h3>
          <div class="tw-space-y-6">
            <div v-if="branch.address">
              <p class="tw-mb-2 tw-text-sm tw-font-semibold tw-uppercase" :style="`color: ${vars.textColor};`">Address</p>
              <p :style="`color: var(--c-primary) !important; font-family: var(--f-primary), sans-serif !important; font-weight: 400 !important; line-height: 110%;`">{{ branch.address }}</p>
            </div>
            <div v-if="branch.phone">
              <p class="tw-mb-2 tw-text-sm tw-font-semibold tw-uppercase" :style="`color: ${vars.textColor};`">Phone</p>
              <a :href="`tel:${branch.phone}`" class="n-link" :style="`color: var(--c-primary) !important;`">{{ branch.phone }}</a>
            </div>
            <div v-if="branch.email">
              <p class="tw-mb-2 tw-text-sm tw-font-semibold tw-uppercase" :style="`color: ${vars.textColor};`">Email</p>
              <a :href="`mailto:${branch.email}`" class="n-link" :style="`color: var(--c-primary) !important;`">{{ branch.email }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>


  <section
    v-if="variants.v4 === variant"
    class="layout-pt-lg layout-pb-lg"
    :style="`background-color: var(--c-${vars.backgroundColor}); color: var(--c-${vars.textColor});`"
  >
    <div class="tw-w-full">
      <div class="tw-space-y-10">
        <div
          v-for="(branch, index) in branches"
          :key="`contact-us-branch-${index}`"
          class="tw-grid tw-grid-cols-1 tw-items-center tw-overflow-hidden xl:tw-grid-cols-2"
        >
          <div class="tw-p-6">
            <LibraryImage :src="branch.photo" :w-ratio="720" :h-ratio="405" />
          </div>

          <div class="tw-p-6 md:tw-p-6 lg:tw-p-10">
            <div>
              <div v-if="vars.titleHtml" class="tw-mb-8" v-html="vars.titleHtml"></div>
            </div>
            <h3 v-if="branch.title" class="tw-mb-4">{{ branch.title }}</h3>

            <div class="tw-grid tw-grid-cols-1 tw-gap-5 lg:tw-grid-cols-2">
              <div class="tw-col-span-1 tw-space-y-8">
                <div class="tw-items-start">
                  <div class="tw-min-w-9"></div>

                  <div class="tw-flex tw-w-full tw-flex-col tw-items-start tw-space-y-2">
                    <small>ADDRESS</small>
                    <nuxt-link
                      v-if="branch.address"
                      :to="branch.address_link"
                      class="n-link"
                      style="color: var(--c-primary) !important; font-weight: 600 !important"
                      :external="true"
                    >
                      {{ branch.address }}
                    </nuxt-link>
                  </div>
                </div>

                <div v-if="branch.primary_phone" class="tw-items-start">
                  <div class="tw-min-w-9"></div>
                  <div class="tw-w-full tw-space-y-2">
                    <small>PHONE</small>
                    <p :style="`color: var(--c-${vars.textColor}) !important;`">
                      <nuxt-link
                        :to="`tel:${branch.primary_phone}`"
                        class="n-link"
                        style="color: var(--c-primary) !important; font-weight: 600 !important"
                        :external="true"
                      >
                        {{ branch.primary_phone }}
                      </nuxt-link>
                    </p>
                  </div>
                </div>

                <!-- E-Posta -->
                <div v-if="branch.primary_email" class="tw-items-start">
                  <div class="tw-min-w-9"></div>
                  <div class="tw-line-clamp-2 tw-space-y-2">
                    <small>EMAIL</small>
                    <p
                      :style="`color: var(--c-primary) !important;`"
                      :title="branch.primary_email"
                      class="scrollbar tw-overflow-x-auto"
                    >
                      <nuxt-link
                        v-if="branch.primary_email"
                        :to="`mailto:${branch.primary_email}`"
                        class="n-link"
                        style="color: var(--c-primary) !important; font-weight: 600 !important"
                        :external="true"
                      >
                        {{ branch.primary_email }}
                      </nuxt-link>
                    </p>
                  </div>
                </div>

                 <div v-if="branch.facebook || branch.youtube || branch.instagram || branch.tiktok || branch.linkedin" class="tw-items-start">
            <p class=" tw-flex tw-flex-row tw-items-center tw-gap-2">
              
              SOCIALS
            </p>
            <div class="socials tw-mt-3 tw-flex tw-flex-row tw-gap-4">
              <nuxt-link
                v-if="branch.facebook"
                :to="branch.facebook"
                class="n-link group tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center !tw-rounded-full tw-border-[1px] hover:tw-bg-[var(--c-primary)]"
                style="border-color: var(--c-primary)"
              >
                <svg
    width="36"
    height="37"
    viewBox="0 0 36 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    @mouseover="
      $event.currentTarget.querySelector('circle').setAttribute('fill', '#8FBB54');
      $event.currentTarget.querySelector('path').setAttribute('fill', 'white');
    "
    @mouseout="
      $event.currentTarget.querySelector('circle').setAttribute('fill', 'white');
      $event.currentTarget.querySelector('path').setAttribute('fill', '#8FBB54');
    "
  >
    <circle cx="18" cy="18.5" r="18" fill="white" />
    <path
      d="M19.3307 19.5007H20.9974L21.6641 16.834H19.3307V15.5007C19.3307 14.814 19.3307 14.1673 20.6641 14.1673H21.6641V11.9273C21.4467 11.8987 20.6261 11.834 19.7594 11.834C17.9494 11.834 16.6641 12.9387 16.6641 14.9673V16.834H14.6641V19.5007H16.6641V25.1673H19.3307V19.5007Z"
      fill="#8FBB54"
    />
  </svg>

              </nuxt-link>
              <nuxt-link
                v-if="branch.instagram"
                :to="branch.instagram"
                class="n-link group tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center !tw-rounded-full tw-border-[1px] hover:tw-bg-[var(--c-primary)]"
                style="border-color: var(--c-primary)"
              >
               <svg @mouseover="
      $event.currentTarget.querySelector('circle').setAttribute('fill', '#8FBB54');
      $event.currentTarget.querySelector('path').setAttribute('fill', 'white');
    "
    @mouseout="
      $event.currentTarget.querySelector('circle').setAttribute('fill', 'white');
      $event.currentTarget.querySelector('path').setAttribute('fill', '#8FBB54');
    " width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="18" cy="18.5" r="18" fill="white"/>
<path d="M15.2026 11.834H20.8026C22.9359 11.834 24.6693 13.5673 24.6693 15.7007V21.3007C24.6693 22.3262 24.2619 23.3097 23.5367 24.0348C22.8116 24.7599 21.8281 25.1673 20.8026 25.1673H15.2026C13.0693 25.1673 11.3359 23.434 11.3359 21.3007V15.7007C11.3359 14.6751 11.7433 13.6916 12.4685 12.9665C13.1936 12.2414 14.1771 11.834 15.2026 11.834ZM15.0693 13.1673C14.4328 13.1673 13.8223 13.4202 13.3722 13.8703C12.9221 14.3203 12.6693 14.9308 12.6693 15.5673V21.434C12.6693 22.7606 13.7426 23.834 15.0693 23.834H20.9359C21.5725 23.834 22.1829 23.5811 22.633 23.131C23.0831 22.681 23.3359 22.0705 23.3359 21.434V15.5673C23.3359 14.2407 22.2626 13.1673 20.9359 13.1673H15.0693ZM21.5026 14.1673C21.7236 14.1673 21.9356 14.2551 22.0919 14.4114C22.2481 14.5677 22.3359 14.7796 22.3359 15.0007C22.3359 15.2217 22.2481 15.4336 22.0919 15.5899C21.9356 15.7462 21.7236 15.834 21.5026 15.834C21.2816 15.834 21.0696 15.7462 20.9133 15.5899C20.7571 15.4336 20.6693 15.2217 20.6693 15.0007C20.6693 14.7796 20.7571 14.5677 20.9133 14.4114C21.0696 14.2551 21.2816 14.1673 21.5026 14.1673ZM18.0026 15.1673C18.8867 15.1673 19.7345 15.5185 20.3596 16.1436C20.9847 16.7687 21.3359 17.6166 21.3359 18.5007C21.3359 19.3847 20.9847 20.2326 20.3596 20.8577C19.7345 21.4828 18.8867 21.834 18.0026 21.834C17.1185 21.834 16.2707 21.4828 15.6456 20.8577C15.0205 20.2326 14.6693 19.3847 14.6693 18.5007C14.6693 17.6166 15.0205 16.7687 15.6456 16.1436C16.2707 15.5185 17.1185 15.1673 18.0026 15.1673ZM18.0026 16.5007C17.4722 16.5007 16.9635 16.7114 16.5884 17.0864C16.2133 17.4615 16.0026 17.9702 16.0026 18.5007C16.0026 19.0311 16.2133 19.5398 16.5884 19.9149C16.9635 20.2899 17.4722 20.5007 18.0026 20.5007C18.533 20.5007 19.0417 20.2899 19.4168 19.9149C19.7919 19.5398 20.0026 19.0311 20.0026 18.5007C20.0026 17.9702 19.7919 17.4615 19.4168 17.0864C19.0417 16.7114 18.533 16.5007 18.0026 16.5007Z" fill="#8FBB54"/>
</svg>

              </nuxt-link>
              <nuxt-link
                v-if="branch.linkedin"
                :to="branch.linkedin"
                class="n-link tw-group tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center !tw-rounded-full tw-border-[1px] hover:tw-bg-[var(--c-primary)]"
                style="border-color: var(--c-primary)"
              >
                <svg @mouseover="
      $event.currentTarget.querySelector('circle').setAttribute('fill', '#8FBB54');
      $event.currentTarget.querySelector('path').setAttribute('fill', 'white');
    "
    @mouseout="
      $event.currentTarget.querySelector('circle').setAttribute('fill', 'white');
      $event.currentTarget.querySelector('path').setAttribute('fill', '#8FBB54');
    " width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="18" cy="18.5" r="18" fill="white"/>
<path d="M14.6276 13.834C14.6274 14.1876 14.4868 14.5267 14.2366 14.7766C13.9864 15.0265 13.6472 15.1668 13.2936 15.1667C12.94 15.1665 12.6009 15.0258 12.351 14.7757C12.1011 14.5255 11.9608 14.1863 11.9609 13.8327C11.9611 13.479 12.1018 13.14 12.3519 12.8901C12.6021 12.6401 12.9413 12.4998 13.2949 12.5C13.6486 12.5002 13.9876 12.6408 14.2376 12.891C14.4875 13.1412 14.6278 13.4804 14.6276 13.834ZM14.6676 16.154H12.0009V24.5007H14.6676V16.154ZM18.8809 16.154H16.2276V24.5007H18.8543V20.1207C18.8543 17.6807 22.0343 17.454 22.0343 20.1207V24.5007H24.6676V19.214C24.6676 15.1007 19.9609 15.254 18.8543 17.274L18.8809 16.154Z" fill="#8FBB54"/>
</svg>

              </nuxt-link>
              <nuxt-link
                v-if="branch.youtube"
                :to="branch.youtube"
                class="n-link group tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center !tw-rounded-full tw-border-[1px] hover:tw-bg-[var(--c-primary)]"
                style="border-color: var(--c-primary)"
              >
               <svg @mouseover="
      $event.currentTarget.querySelector('circle').setAttribute('fill', '#8FBB54');
      $event.currentTarget.querySelector('path').setAttribute('fill', 'white');
    "
    @mouseout="
      $event.currentTarget.querySelector('circle').setAttribute('fill', 'white');
      $event.currentTarget.querySelector('path').setAttribute('fill', '#8FBB54');
    "  width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="18" cy="18.5" r="18" fill="white"/>
<path d="M18.0026 13.166C18.5726 13.166 19.1573 13.1807 19.7239 13.2047L20.3933 13.2367L21.0339 13.2747L21.6339 13.3153L22.1819 13.358C22.7766 13.4035 23.3362 13.6573 23.7623 14.0747C24.1883 14.4921 24.4536 15.0464 24.5113 15.64L24.5379 15.9233L24.5879 16.53C24.6346 17.1587 24.6693 17.844 24.6693 18.4993C24.6693 19.1547 24.6346 19.84 24.5879 20.4687L24.5379 21.0753C24.5293 21.1727 24.5206 21.2667 24.5113 21.3587C24.4535 21.9524 24.1882 22.5068 23.762 22.9242C23.3358 23.3416 22.7761 23.5953 22.1813 23.6407L21.6346 23.6827L21.0346 23.724L20.3933 23.762L19.7239 23.794C19.1505 23.8189 18.5766 23.8318 18.0026 23.8327C17.4286 23.8318 16.8547 23.8189 16.2813 23.794L15.6119 23.762L14.9713 23.724L14.3713 23.6827L13.8233 23.6407C13.2286 23.5952 12.669 23.3414 12.2429 22.924C11.8169 22.5066 11.5517 21.9523 11.4939 21.3587L11.4673 21.0753L11.4173 20.4687C11.3663 19.8134 11.3392 19.1566 11.3359 18.4993C11.3359 17.844 11.3706 17.1587 11.4173 16.53L11.4673 15.9233C11.4759 15.826 11.4846 15.732 11.4939 15.64C11.5516 15.0465 11.8167 14.4923 12.2427 14.0749C12.6686 13.6575 13.228 13.4037 13.8226 13.358L14.3699 13.3153L14.9699 13.2747L15.6113 13.2367L16.2806 13.2047C16.8543 13.1798 17.4284 13.1669 18.0026 13.166ZM18.0026 14.4993C17.4526 14.4993 16.8866 14.514 16.3359 14.5367L15.6839 14.568L15.0579 14.6047L14.4699 14.6447L13.9313 14.6867C13.6482 14.7068 13.3813 14.8264 13.178 15.0245C12.9747 15.2226 12.8481 15.4862 12.8206 15.7687C12.7426 16.5747 12.6693 17.578 12.6693 18.4993C12.6693 19.4207 12.7426 20.424 12.8206 21.23C12.8773 21.8113 13.3386 22.2633 13.9313 22.312L14.4699 22.3533L15.0579 22.3933L15.6839 22.4307L16.3359 22.462C16.8866 22.4847 17.4526 22.4993 18.0026 22.4993C18.5526 22.4993 19.1186 22.4847 19.6693 22.462L20.3213 22.4307L20.9473 22.394L21.5353 22.354L22.0739 22.312C22.357 22.2919 22.6239 22.1723 22.8272 21.9742C23.0305 21.7761 23.1571 21.5125 23.1846 21.23C23.2626 20.424 23.3359 19.4207 23.3359 18.4993C23.3359 17.578 23.2626 16.5747 23.1846 15.7687C23.1571 15.4862 23.0305 15.2226 22.8272 15.0245C22.6239 14.8264 22.357 14.7068 22.0739 14.6867L21.5353 14.6453L20.9473 14.6053L20.3213 14.568L19.6693 14.5367C19.114 14.5128 18.5584 14.5003 18.0026 14.4993ZM16.6693 16.8827C16.6692 16.8175 16.6851 16.7533 16.7155 16.6957C16.7459 16.6381 16.79 16.5888 16.8438 16.552C16.8976 16.5153 16.9596 16.4923 17.0243 16.485C17.0891 16.4776 17.1546 16.4862 17.2153 16.51L17.2693 16.5367L20.0693 18.1527C20.125 18.1849 20.1722 18.23 20.2068 18.2843C20.2413 18.3386 20.2623 18.4004 20.2679 18.4646C20.2734 18.5287 20.2634 18.5932 20.2387 18.6527C20.214 18.7121 20.1753 18.7647 20.1259 18.806L20.0693 18.846L17.2693 20.4627C17.2128 20.4954 17.1493 20.5137 17.0841 20.5162C17.019 20.5187 16.9542 20.5053 16.8954 20.477C16.8367 20.4487 16.7857 20.4065 16.747 20.3541C16.7083 20.3016 16.683 20.2405 16.6733 20.176L16.6693 20.116V16.8827Z" fill="#8FBB54"/>
</svg>

              </nuxt-link>
              <nuxt-link
                v-if="branch.tiktok"
                :to="branch.tiktok"
                class="n-link group tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center !tw-rounded-full tw-border-[1px] hover:tw-bg-[var(--c-primary)]"
                style="border-color: var(--c-primary)"
              >
               <svg @mouseover="
      $event.currentTarget.querySelector('circle').setAttribute('fill', '#8FBB54');
      $event.currentTarget.querySelector('path').setAttribute('fill', 'white');
    "
    @mouseout="
      $event.currentTarget.querySelector('circle').setAttribute('fill', 'white');
      $event.currentTarget.querySelector('path').setAttribute('fill', '#8FBB54');
    " width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="18" cy="18.5" r="18" fill="white"/>
<path d="M21.0668 14.38C20.6111 13.8597 20.3599 13.1916 20.3601 12.5H18.3001V20.7667C18.2842 21.214 18.0954 21.6377 17.7733 21.9486C17.4512 22.2595 17.0211 22.4333 16.5734 22.4333C15.6268 22.4333 14.8401 21.66 14.8401 20.7C14.8401 19.5533 15.9468 18.6933 17.0868 19.0467V16.94C14.7868 16.6333 12.7734 18.42 12.7734 20.7C12.7734 22.92 14.6134 24.5 16.5668 24.5C18.6601 24.5 20.3601 22.8 20.3601 20.7V16.5067C21.1954 17.1066 22.1983 17.4284 23.2268 17.4267V15.3667C23.2268 15.3667 21.9734 15.4267 21.0668 14.38Z" fill="#8FBB54"/>
</svg>

              </nuxt-link>
            </div>
          </div>
              </div>

              <div>
                <div class="tw-items-start">
                  <div class="tw-w-9"></div>
                  <div class="tw-w-full">
                    <small>OPENING HOURS</small>
                    <div>
                      <div class="tw-mt-4 tw-space-y-4 tw-text-[#545454]">
                        <div class="tw-flex tw-justify-between">
                          <p :style="`color: var(--c-${vars.textColor}) !important;`">Monday:</p>
                          <p :style="`color: var(--c-${vars.textColor}) !important;`">{{ branch.monday }}</p>
                        </div>
                        <div class="tw-flex tw-justify-between">
                          <p :style="`color: var(--c-${vars.textColor}) !important;`">Tuesday:</p>
                          <p :style="`color: var(--c-${vars.textColor}) !important;`">{{ branch.tuesday }}</p>
                        </div>
                        <div class="tw-flex tw-justify-between">
                          <p :style="`color: var(--c-${vars.textColor}) !important;`">Wednesday:</p>
                          <p :style="`color: var(--c-${vars.textColor}) !important;`">{{ branch.wednesday }}</p>
                        </div>
                        <div class="tw-flex tw-justify-between">
                          <p :style="`color: var(--c-${vars.textColor}) !important;`">Thursday:</p>
                          <p :style="`color: var(--c-${vars.textColor}) !important;`">{{ branch.thursday }}</p>
                        </div>
                        <div class="tw-flex tw-justify-between">
                          <p :style="`color: var(--c-${vars.textColor}) !important;`">Friday:</p>
                          <p :style="`color: var(--c-${vars.textColor}) !important;`">{{ branch.friday }}</p>
                        </div>
                        <div class="tw-flex tw-justify-between">
                          <p :style="`color: var(--c-${vars.textColor}) !important;`">Saturday:</p>
                          <p :style="`color: var(--c-${vars.textColor}) !important;`">{{ branch.saturday }}</p>
                        </div>
                        <div class="tw-flex tw-justify-between">
                          <p :style="`color: var(--c-${vars.textColor}) !important;`">Sunday:</p>
                          <p :style="`color: var(--c-${vars.textColor}) !important;`">{{ branch.sunday }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'ContactUs',
  mixins: [ComponentMixin],

  data() {
    return {
      variants: {
        v1: 'v1',
        v2: 'v2',
        v3: 'v3',
        v4: 'v4',
      },
      form: null,
    };
  },

  computed: {
    branches() {
      return this.groupedVariables.branches;
    },
    buttons() {
      return this.groupedVariables.buttons;
    },
  },
});
</script>

<style scoped>
.social_icons {
  border-radius: 100% !important;
  padding: 10px !important;
}

.scrollbar::-webkit-scrollbar {
  height: 3px;
  width: 6px;
}

.scrollbar::-webkit-scrollbar-track {
  background-color: #cbdceb;
  border-radius: 40px;
}



.scrollbar::-webkit-scrollbar-thumb {
  background-color: var(--c-primary);
  border-radius: 40px;
}

@media screen and (min-width: 1024px) {
  .scrollbar::-webkit-scrollbar {
    height: 5px;
  }
}
</style>
